<template>
  <el-dialog
    v-drag
    :visible.sync="dialogVisible"
    width="500px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <span slot="title">
      <img src="@/assets/images/system/company.png" />修改信息
    </span>
    <div class="content">
      <el-form ref="form" class="form" :model="form" :rules="rules">
        <el-form-item prop="nameCH" label="中文名称">
          <el-input v-model="form.nameCH" placeholder="请输入中文名称"></el-input>
        </el-form-item>
        <el-form-item prop="phoneNumber" label="手机">
          <el-input v-model="form.phoneNumber" placeholder="请输入手机"></el-input>
        </el-form-item>
        <el-form-item prop="email" label="邮箱">
          <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel" @click="cancel">取 消</div>
      <div class="ok" @click="ok('form')">确 定</div>
    </span>
  </el-dialog>
</template>

<script>
import { updateUserData } from '@/api/system'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: {
        nameCH: '',
        phoneNumber: '',
        email: ''
      },
      rules: {
        nameCH: [{ required: true, message: '请输入中文名称', trigger: 'blur' }],
         phoneNumber: [{ required: true, message: '请输入手机', trigger: 'blur' }]
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.form = {
          ...this.rowData,
          nameCH: this.rowData.userName
        }
      }
    }
  },
  methods: {
    cancel() {
      this.$refs['form']?.resetFields()
      this.$emit('cancel')
    },
    ok(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
         try {
          const res = await updateUserData({
            userId: this.rowData.userId,
            ...this.form
          })
          if (res.success) {
            this.$message.success('修改成功')
            this.$emit('ok')
          } else {
            this.$message.error(res.errorMessage)
          }
         } catch (error) {
          console.log(error)
         }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding-bottom: 0;
}
.footers {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    margin-left: 20px;
    cursor: pointer;
  }
}
</style>
